import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_LEAD_TIME_FOR_CHANGES_RANGE } from "./gql";

type UseGetLeadTimeForChangesRangeProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetLeadTimeForChangesRange = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetLeadTimeForChangesRangeProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_LEAD_TIME_FOR_CHANGES_RANGE,
    {
      variables: {
        input: {
          startTime: startTimeUnix,
          endTime: endTimeUnix,
          timezone: null,
        },
      },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend DataPoints (timestamp unix and value in seconds)
  const range =
    data?.metricsRange?.averageLeadTimeForChangesRange ??
    previousData?.metricsRange?.averageLeadTimeForChangesRange;

  return {
    range,
    hasRuns: !!data?.metricsRange?.hasRuns,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetLeadTimeForChangesRange;
